"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transitStatsQuery = exports.transitSystemsQuery = exports.vehicleLifeQuery = exports.countyQuery = exports.grantsQuery = exports.coreDataQuery = void 0;
const helpers_1 = require("./helpers");
const PortalURLs_1 = require("./PortalURLs");
const CoreData_1 = __importDefault(require("../ESRIResponses/CoreData"));
const CountyData_1 = __importDefault(require("../ESRIResponses/CountyData"));
const AgencyData_1 = __importDefault(require("../ESRIResponses/AgencyData"));
const GrantData_1 = __importDefault(require("../ESRIResponses/GrantData"));
const coreDataQuery = (requestData, token) => {
    return new Promise((resolve, reject) => {
        const [url, query] = helpers_1.genQuery(requestData, PortalURLs_1.PortalURLs.CORE_URLS);
        helpers_1.runQuery(url, query, token, '', true)
            .then((queryRes) => {
            let theData = {
                ...queryRes?.[0]?.attributes,
                geometry: queryRes?.[0]?.geometry,
            };
            resolve(CoreData_1.default.init(requestData.type, theData));
            resolve(queryRes);
        })
            .catch((error) => {
            reject(error);
        });
    });
};
exports.coreDataQuery = coreDataQuery;
const grantsQuery = (requestData, token) => {
    return new Promise((resolve, reject) => {
        const [url, query] = helpers_1.genQuery(requestData, PortalURLs_1.PortalURLs.GRANTS_URLS);
        helpers_1.runQuery(url, query, token, "Allocation DESC")
            .then((queryRes) => {
            resolve(new GrantData_1.default(requestData.type, queryRes));
            resolve(queryRes);
        })
            .catch((error) => {
            reject(error);
        });
    });
};
exports.grantsQuery = grantsQuery;
const countyQuery = (requestData, token) => {
    return new Promise((resolve, reject) => {
        const [url, query] = helpers_1.genQuery(requestData, PortalURLs_1.PortalURLs.COUNTY_URLS);
        helpers_1.runQuery(url, query, token, "pop_public_trans DESC")
            .then((queryRes) => {
            resolve(new CountyData_1.default(requestData.type, queryRes));
        })
            .catch((error) => {
            reject(error);
        });
    });
};
exports.countyQuery = countyQuery;
const vehicleLifeQuery = (requestData, token) => {
    return new Promise((resolve, reject) => {
        const [url, query] = helpers_1.genQuery(requestData, PortalURLs_1.PortalURLs.AGENCY_URLS);
        helpers_1.runQuery(url, query, token, "Service_Area_Pop DESC")
            .then((queryRes) => {
            resolve(new AgencyData_1.default(requestData.type, queryRes));
        })
            .catch((error) => {
            reject(error);
        });
    });
};
exports.vehicleLifeQuery = vehicleLifeQuery;
const transitSystemsQuery = (requestData, token) => {
    return new Promise((resolve, reject) => {
        const [url, query] = helpers_1.genQuery(requestData, PortalURLs_1.PortalURLs.AGENCY_URLS);
        helpers_1.runQuery(url, query, token, "Service_Area_Pop DESC")
            .then((queryRes) => {
            //resolve(queryRes);
            resolve(new AgencyData_1.default(requestData.type, queryRes));
        })
            .catch((error) => {
            reject(error);
        });
    });
};
exports.transitSystemsQuery = transitSystemsQuery;
const transitStatsQuery = (requestData, token) => {
    return new Promise((resolve, reject) => {
        const [url, query] = helpers_1.genQuery(requestData, PortalURLs_1.PortalURLs.AGENCY_URLS);
        helpers_1.runQuery2(url, query, token)
            .then((queryRes) => {
            //resolve(queryRes);
            resolve(queryRes);
        })
            .catch((error) => {
            reject(error);
        });
    });
};
exports.transitStatsQuery = transitStatsQuery;
